export default "__VITE_PUBLIC_ASSET__e1871787__"